"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _component = _interopRequireDefault(require("../component.js"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*---------------------------------------------*/
var RangeSlider = /*#__PURE__*/function (_Component) {
  _inherits(RangeSlider, _Component);

  var _super = _createSuper(RangeSlider);

  function RangeSlider() {
    var _this;

    _classCallCheck(this, RangeSlider);

    _this = _super.call(this);
    _this.state = {};
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.onMouseDown = _this.onMouseDown.bind(_assertThisInitialized(_this));
    _this.onMouseMove = _this.onMouseMove.bind(_assertThisInitialized(_this));
    _this.onMouseUp = _this.onMouseUp.bind(_assertThisInitialized(_this));
    _this.onTrackClick = _this.onTrackClick.bind(_assertThisInitialized(_this));
    _this.onPositionChange = _this.onPositionChange.bind(_assertThisInitialized(_this));
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(RangeSlider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("mousemove", this.onMouseMove);
      document.addEventListener("mouseup", this.onMouseUp);
    }
  }, {
    key: "onChange",
    value: function onChange(value) {
      this.setState({
        value: value
      });
      this.props.onChange && this.props.onChange(value, this.props.name);
    }
  }, {
    key: "onMouseUp",
    value: function onMouseUp(e) {
      this.setState({
        dragging: false
      });
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(e) {
      if (e.button !== 0) return;
      this.setState({
        dragging: true
      }); // e.stopPropagation();
      // e.preventDefault();
    }
  }, {
    key: "onTrackClick",
    value: function onTrackClick(e) {
      this.setState({
        dragging: true
      });
      this.onPositionChange(e.pageX);
    }
  }, {
    key: "onPositionChange",
    value: function onPositionChange(offset) {
      var totalWidth = this.ref.current.offsetWidth;
      var x = offset - this.ref.current.getBoundingClientRect().left;
      var min = 1 * this.props.min || 0;
      var max = 1 * this.props.max || 100;
      var value = min + (max - min) * (x / totalWidth);
      value = Math.min(value, max);
      value = Math.max(value, min);

      if (!this.props.floatingNumber) {
        value = Math.round(value);
      }

      this.onChange(value);
    }
  }, {
    key: "onMouseMove",
    value: function onMouseMove(e) {
      if (!this.state.dragging) return;
      this.onPositionChange(e.pageX);
      e.stopPropagation();
      e.preventDefault();
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      var value = this.props.value || this.state.value || 0;

      switch (event.key) {
        case "ArrowRight":
          {
            value += 1;
            break;
          }

        case "ArrowLeft":
          {
            value -= 1;
            break;
          }

        default:
          break;
      }

      if (value !== this.state.value) {
        var min = 1 * this.props.min || 0;
        var max = 1 * this.props.max || 100;
        value = Math.min(value, max);
        value = Math.max(value, min);
        this.onChange(value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      this.resetClassNames();
      this.addClass(this.constructor.BASE_CLASS);
      var min = 1 * this.props.min || 0;
      var max = 1 * this.props.max || 100;
      var value = this.props.value || this.state.value || 0;
      value = Math.min(value, max);
      value = Math.max(value, min);
      var handleSize = 12;
      var trackPadding = handleSize / 2; // half of the handle size

      var percent = 100 * (value - min) / (max - min);
      var containerWidth = "calc(".concat(trackPadding, "px + (100% - ").concat(trackPadding * 2, "px) * ").concat(percent, " / 100)");
      var styles = {
        container: {
          width: containerWidth
        }
      };
      var valueElement = null;

      switch (this.props.valueType) {
        case "number":
          {
            valueElement = /*#__PURE__*/_react.default.createElement("div", {
              className: this.constructor.BASE_CLASS + "__value--number-input"
            }, /*#__PURE__*/_react.default.createElement(_.Input, {
              type: "number",
              value: value,
              disabled: this.props.disabled,
              size: "slim",
              min: min,
              max: max,
              onChange: this.onChange
            }));
            break;
          }

        case "text":
          {
            valueElement = /*#__PURE__*/_react.default.createElement("div", {
              className: this.constructor.BASE_CLASS + "__value--text-input"
            }, /*#__PURE__*/_react.default.createElement(_.Input, {
              value: value,
              size: "slim",
              disabled: this.props.disabled,
              onChange: this.onChange
            }));
            break;
          }

        case "plain":
          {
            valueElement = /*#__PURE__*/_react.default.createElement("div", {
              className: this.constructor.BASE_CLASS + "__value--text"
            }, /*#__PURE__*/_react.default.createElement(_.Text, {
              disabled: this.props.disabled
            }, value));
            break;
          }

        default:
          break;
      }

      var label = this.props.label && /*#__PURE__*/_react.default.createElement(_.Label, {
        disabled: this.props.disabled
      }, this.props.label);

      return /*#__PURE__*/_react.default.createElement("div", {
        style: this.getStyle(),
        className: this.getClassNames(),
        onKeyDown: this.onKeyDown,
        tabIndex: this.props.disabled ? false : 0
      }, label, /*#__PURE__*/_react.default.createElement("div", {
        className: this.constructor.BASE_CLASS + "__control"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: this.constructor.BASE_CLASS + "__track",
        onMouseDown: this.onTrackClick,
        ref: this.ref
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: this.constructor.BASE_CLASS + "__fill-container",
        style: styles.container
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: this.constructor.BASE_CLASS + "__fill"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: this.constructor.BASE_CLASS + "__handle",
        onMouseDown: this.onMouseDown
      }))), valueElement));
    }
  }]);

  return RangeSlider;
}(_component.default);
/*---------------------------------------------*/


exports.default = RangeSlider;

_defineProperty(RangeSlider, "BASE_CLASS", "lth-c-rangeslider");

RangeSlider.METADATA = {
  name: "Rangeslider",
  props: [{
    name: "label",
    type: "string",
    default: "Range slider label"
  }, {
    name: "valueType",
    type: "string",
    default: "number",
    options: [{
      value: "none"
    }, {
      value: "plain"
    }, {
      value: "text"
    }, {
      value: "number"
    }],
    category: "value"
  }, {
    name: "units",
    type: "string"
  }, {
    name: "min",
    type: "number",
    category: "value"
  }, {
    name: "max",
    type: "number",
    category: "value"
  }, {
    name: "value",
    type: "number"
  }, {
    name: "disabled",
    type: "boolean",
    default: false
  }, {
    name: "forcehover",
    type: "boolean",
    default: false
  }, {
    name: "forcefocus",
    type: "boolean",
    default: false
  }, {
    name: "onChange",
    type: "function"
  }]
};